export default __webpack_public_path__ + "static/media/jpos.204b1c24.yaml";